import { render } from "./userDashboard.vue?vue&type=template&id=a4c25e56&scoped=true&ts=true"
import script from "./userDashboard.vue?vue&type=script&lang=ts"
export * from "./userDashboard.vue?vue&type=script&lang=ts"

import "./userDashboard.vue?vue&type=style&index=0&id=a4c25e56&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4c25e56"]])

export default __exports__